import { Login } from '../components/pages/login';

export const publicListRoutes = [
  {
    path: '/login',
    component: Login,
    onAuthRoute: '/',
  },
];
